import React, { useState, useEffect, useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import logo from './THEDATCHAINlogo.png';
import { AppContext } from './AppContext';

const Navigation = () => {
      const { isAllowed,
          setIsAllowed } = useContext(AppContext);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentUser, setCurrentUser]         = useState(null);

  const [isMarketOpen, setMarketOpen] = useState(false);

const handleMarketLink = (site) => {
  const map = {
    spndat: 'https://spndat.com/',
    sfr: 'https://streetflavorrecords.com/',
    youngstruggle: 'https://youngstruggle615.com',
    bypassthemaster: 'https://bypassthemaster.com',
    youngbuck: 'https://youngbuck615.com',
    abizarreworld: 'https://abizarreworld.com',
    dattickets: 'https://dattickets.com',
    thevidbox: 'https://thevidbox.com'
  };
  const url = map[site];
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
  setMarketOpen(false);
  setMobileMenuOpen(false);
};



const toggleMobileMenu = () => {
  setMobileMenuOpen(prev => {
    const next = !prev;
    if (!next) setMarketOpen(false); // close sub-menu when hamburger closes
    return next;
  });
};


  const navigate = useNavigate();
  const auth     = getAuth();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, user => setCurrentUser(user));
    return unsub;
  }, [auth]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setMobileMenuOpen(false);
      navigate('/');
    } catch (e) {
      console.error('Logout error:', e.message);
    }
  };

  const linkClass = ({ isActive }) => `nav__link${isActive ? ' nav__link--active' : ''}`;

  return (
    <>
      <nav className="nav">
        <div
          className="nav__brand"
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        >
          <img src={logo} alt="Logo" className="nav__logo" />
          THE DAT CHAIN
        </div>

        <button
          className="nav__toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation"
        >
          <span className="hamburger"></span>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
        </button>

        <ul className={`nav__list ${isMobileMenuOpen ? 'nav__list--open' : ''}`}>
          <li className="nav__item">
            <NavLink to="/"   className={linkClass} onClick={() => setMobileMenuOpen(false)}>TOKENS</NavLink>
          </li>
          <li className="nav__item">
            <NavLink to="/dats"   className={linkClass} onClick={() => setMobileMenuOpen(false)}>DATS</NavLink>
          </li>
                    {currentUser && (
          <li className="nav__item">
            <NavLink to="/wallet" className={linkClass} onClick={() => setMobileMenuOpen(false)}>WALLET</NavLink>
          </li>
          )}
          {currentUser && isAllowed && (
            <li className="nav__item">
              <NavLink to="/release" className={linkClass} onClick={() => setMobileMenuOpen(false)}>RELEASE</NavLink>
            </li>
          )}

                    {currentUser && isAllowed && (
            <li className="nav__item">
              <NavLink to="/admin" className={linkClass} onClick={() => setMobileMenuOpen(false)}>ADMIN</NavLink>
            </li>
          )}

<li className="nav__item nav__dropdown">
  <button
    className="nav__link nav__dropdown-btn"
    onClick={() => setMarketOpen((v) => !v)}
    aria-haspopup="true"
    aria-expanded={isMarketOpen}
  >
    TDC MARKET PLACE
    <span className={`caret ${isMarketOpen ? 'up' : ''}`}></span>
  </button>

  <ul className={`nav__dropdown-menu ${isMarketOpen ? 'open' : ''}`}>
    <li>
      <button className="nav__dropdown-link" onClick={() => handleMarketLink('spndat')}>
        SPNDAT
      </button>
    </li>
    <li>
      <button className="nav__dropdown-link" onClick={() => handleMarketLink('sfr')}>
        STREET FLAVOR RECORDS
      </button>
    </li>
    <li>
  <button className="nav__dropdown-link" onClick={() => handleMarketLink('dattickets')}>
    DAT TICKETS
  </button>
</li>
<li>
  <button className="nav__dropdown-link" onClick={() => handleMarketLink('thevidbox')}>
    THE VID BOX
  </button>
</li>
<li>
  <button className="nav__dropdown-link" onClick={() => handleMarketLink('bypassthemaster')}>
    BYPASS THE MASTER
  </button>
</li>
    <li>
  <button className="nav__dropdown-link" onClick={() => handleMarketLink('youngbuck')}>
    YOUNG BUCK
  </button>
</li>
    <li>
  <button className="nav__dropdown-link" onClick={() => handleMarketLink('youngstruggle')}>
    YOUNG STRUGGLE
  </button>
</li>

<li>
  <button className="nav__dropdown-link" onClick={() => handleMarketLink('abizarreworld')}>
    A BIZARRE WORLD
  </button>
</li>


  </ul>
</li>


          <li className="nav__item">
            <NavLink to="/about"  className={linkClass} onClick={() => setMobileMenuOpen(false)}>ABOUT</NavLink>
          </li>

          {currentUser ? (
            <li className="nav__item">
              <button className="nav__link nav__logout-button" onClick={handleLogout}>LOG OUT</button>
            </li>
          ) : (
            <li className="nav__item">
              <NavLink to="/login" className={linkClass} onClick={() => setMobileMenuOpen(false)}>LOG IN</NavLink>
            </li>
          )}
        </ul>
      </nav>

<style>{`
  :root{
    --brand-top:#fe24ad;
    --brand-bot:#a410e8;
    --brand-grad:linear-gradient(135deg,var(--brand-top),var(--brand-bot));
    --brand-bot-40:rgba(164,16,232,.4);
    --ink:#fff;
    --bg:#000;
  }

  .nav{
    position:sticky;top:0;width:100%;
    background:rgba(0,0,0,.75);
    backdrop-filter:saturate(140%) blur(6px);
    padding:1rem 2rem;
    z-index:1000;
    display:flex;align-items:center;justify-content:space-between;
    box-shadow:0 6px 24px rgba(0,0,0,.45);
  }
  .nav::after{
    content:"";position:absolute;left:0;right:0;bottom:0;height:2px;
    background:var(--brand-grad);
  }

  .nav__logo{width:32px;height:32px;margin-right:.5rem;vertical-align:middle;}

  .nav__brand{
    display:flex;align-items:center;gap:.5rem;
    font-size:1.35rem;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;
    color:transparent;background:var(--brand-grad);
    -webkit-background-clip:text;background-clip:text;
    text-shadow:0 0 18px rgba(164,16,232,.25);
  }

  .nav__toggle{display:none;background:none;border:none;cursor:pointer;padding:0;}
  .hamburger{
    display:block;width:26px;height:3px;margin:5px auto;border-radius:3px;
    background:var(--brand-grad);
    transition:transform .3s,opacity .3s;
    box-shadow:0 0 10px rgba(254,36,173,.35);
  }

  .nav__list{list-style:none;display:flex;align-items:center;margin:0;padding:0;}
  .nav__item{margin-left:2rem;}

  .nav__link{
    font-size:1rem;font-weight:600;
    color:rgba(255,255,255,.85);
    text-decoration:none;position:relative;padding:.5rem;
    background:transparent;border:none;cursor:pointer;
    transition:color .25s ease, opacity .25s ease;
  }
  .nav__link::after{
    content:"";position:absolute;left:0;bottom:0;width:100%;height:2px;
    background:var(--brand-grad);transform:scaleX(0);transform-origin:right;
    transition:transform .25s ease;
    box-shadow:0 0 12px rgba(254,36,173,.35);
  }
  .nav__link:hover{color:#fff;}
  .nav__link:hover::after{transform:scaleX(1);transform-origin:left;}

  .nav__link--active{
    color:transparent;background:var(--brand-grad);
    -webkit-background-clip:text;background-clip:text;
    text-shadow:0 0 14px rgba(164,16,232,.25);
  }
  .nav__link--active::after{transform:scaleX(1);}

  .nav__logout-button{background:transparent;color:rgba(255,255,255,.85);}

  /* dropdown container */
.nav__dropdown{ position:relative; }

/* button caret */
.nav__dropdown-btn{ display:flex; align-items:center; gap:.35rem; }
.caret{
  display:inline-block; width:0; height:0;
  border-left:5px solid transparent; border-right:5px solid transparent;
  border-top:6px solid rgba(255,255,255,.85); transition:transform .2s ease;
}
.caret.up{ transform:rotate(180deg); }

/* menu panel */
.nav__dropdown-menu{
  position:absolute; top:110%; left:0; min-width:220px;
  background:#0b0611; border:1px solid rgba(255,255,255,.12);
  border-radius:10px; padding:.4rem 0; list-style:none;
  box-shadow:0 10px 24px rgba(0,0,0,.45);
  opacity:0; pointer-events:none; transform:translateY(-4px);
  transition:opacity .18s ease, transform .18s ease;
  z-index:1001;
}
.nav__dropdown-menu.open{
  opacity:1; pointer-events:auto; transform:translateY(0);
}

.nav__dropdown-link{
  width:100%; text-align:left; padding:.55rem .9rem;
  background:transparent; border:none; cursor:pointer;
  color:rgba(255,255,255,.9); font-weight:600;
}
.nav__dropdown-link:hover{
  background:rgba(255,255,255,.06); color:#fff;
}

.nav__dropdown-menu{ display:none; }
.nav__dropdown-menu.open{ display:block; }



@media (max-width:600px){
  .nav__dropdown{ width:100%; }
  .nav__dropdown-menu{
    position:static;
    min-width:unset;
    margin-top:.25rem;
    box-shadow:none;
    border-radius:8px;
    transform:none;
    /* DO NOT force opacity/pointer-events/display here — the .open class controls visibility */
  }
}



  @media (max-width:600px){
    .nav__toggle{display:block;}
    .nav__list{
      position:absolute;top:100%;left:0;width:100%;
      background:#050008;flex-direction:column;align-items:center;padding:0;margin:0;
      max-height:0;overflow:hidden;transition:max-height .3s ease;
      border-bottom:1px solid var(--brand-bot-40);
      box-shadow:0 10px 30px rgba(0,0,0,.5);
    }
    .nav__list--open{padding:.5rem 0;max-height:450px;}
    .nav__item{width:100%;margin:0;text-align:center;}
    .nav__link{display:block;width:100%;}
  }

.nav__dropdown-link{
  width:100%; text-align:left; padding:.6rem 1rem;
  background:transparent; border:none; cursor:pointer;
  color:rgba(255,255,255,.9); font-weight:600;
  display:flex; align-items:center; gap:.65rem;   /* enable dot + spacing */
}

.nav__dropdown-link::before{
  content:"";
  display:inline-block;
  width:7px; height:7px; border-radius:50%;
  background:var(--brand-top);                 /* The DAT Chain theme color */
  box-shadow:0 0 6px var(--brand-bot-40);      /* subtle on-brand glow */
  flex:0 0 7px;
}


.nav__dropdown-link:hover{
  background:rgba(255,255,255,.06);
  color:#fff;
}

@media (max-width:600px){
  .nav__dropdown-link{
    padding:.7rem 1rem;
    justify-content:flex-start;               /* keep left-aligned on mobile */
  }
  .nav__dropdown-link::before{
    margin-right:.1rem;                       /* tiny extra breathing room */
  }
}



`}</style>

    </>
  );
};

export default Navigation;
